import { variant } from 'styled-system'
import colors from '../../constants/colors'
import { InputProps } from './Input.types'

export const inputVariant = (props: InputProps) =>
  variant({
    prop: 'size',
    variants: {
      regular: {
        boxSizing: 'border-box',
        width: '100% ',
        lineHeight: '22px',
        padding: '12px 16px',
        borderRadius: '8px',
        border: props.noBorder
          ? 'none'
          : `solid 1px ${props.isError ? colors.red50 : colors.black10}`,
        color: colors.black75,
        '&:focus,&:hover': {
          borderColor: props.isError ? colors.red50 : colors.blue50,
          outline: 'none',
        },
        '&:disabled': {
          backgroundColor: colors.black5,
          borderColor: colors.black5,
          cursor: 'not-allowed',
        },
        '&::placeholder': {
          color: colors.black25,
          fontSize: '14px',
        },
      },
      small: {
        boxSizing: 'border-box',
        width: '100%',
        lineHeight: '22px',
        padding: '8px 12px',
        borderRadius: '8px',
        border: props.noBorder
          ? 'none'
          : `solid 1px ${props.isError ? colors.red50 : colors.black10}`,
        color: colors.black75,
        '&:focus,&:hover': {
          borderColor: props.isError ? colors.red50 : colors.blue50,
          outline: 'none',
        },
        '&:disabled': {
          backgroundColor: colors.black5,
          borderColor: colors.black5,
          cursor: 'not-allowed',
        },
        '&::placeholder': {
          color: colors.black25,
          fontSize: '14px',
        },
      },
    },
  })

export const inputWrapperVariant = (props: InputProps) => {
  const noBorder = props.disabled || props.noBorder
  return variant({
    prop: 'size',
    variants: {
      regular: {
        boxSizing: 'border-box',
        padding: '12px 16px',
        columnGap: '8px',
        width: '100%',
        alignItems: 'center',
        borderRadius: '8px',
        border: noBorder ? 'none' : `solid 1px ${props.isError ? colors.red50 : colors.black10}`,
        color: colors.black75,
        '&:focus, &:hover': {
          borderColor: noBorder ? 'none' : props.isError ? colors.red50 : colors.blue50,
          outline: 'none',
        },

        '&:disabled': {
          backgroundColor: colors.black5,
          borderColor: colors.black5,
          cursor: 'not-allowed',
        },
        '&::placeholder': {
          color: colors.black25,
          fontSize: '14px',
        },

        svg: {
          flexShrink: 0,
          path: {
            fill: colors.black50,
          },
        },
      },
      small: {
        boxSizing: 'border-box',
        padding: '8px 12px',
        width: '100%',
        columnGap: '8px',
        alignItems: 'center',
        borderRadius: '8px',
        border: noBorder ? 'none' : `solid 1px ${props.isError ? colors.red50 : colors.black10}`,
        color: colors.black75,
        '&:focus, &:hover': {
          borderColor: props.isError ? colors.red50 : colors.blue50,
          outline: 'none',
        },

        '&:disabled': {
          backgroundColor: colors.black5,
          borderColor: colors.black5,
          cursor: 'not-allowed',
        },
        '&::placeholder': {
          color: colors.black25,
          fontSize: '14px',
        },

        svg: {
          flexShrink: 0,
          path: {
            fill: colors.black50,
          },
        },
      },
    },
  })
}
